import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { useEffect } from 'react'

import { useHook } from '../../../lenteHooks'
import { withLifeErrorBoundary } from '../../../libs/withLifeErrorBoundary'
import type { StopAlertsProps } from '../../participantOverview/participant/types'

const MoneyInCompaniesBundlingStopAlertInternal = ({
  onHandleResourcesInStop,
}: StopAlertsProps) => {
  const translate = useTranslate()

  const { tenantId, companyId } = useHook('routing.company.useCompanyParams')()
  const { data: isInStop } = useHook(
    'fetchers.moneyIn.useFetchMoneyInCompaniesBundlingStops',
  )({
    tenantId,
    companyId,
  })

  useEffect(() => {
    onHandleResourcesInStop((x) => ({ ...x, moneyIn: !!isInStop }))
  }, [isInStop, onHandleResourcesInStop])

  return (
    isInStop && (
      <Alert severity="warning">
        {`${translate('stopAlert.invoiceCreation')}: ${translate('status.stopped')}`}
      </Alert>
    )
  )
}

export const MoneyInCompaniesBundlingStopAlert = withLifeErrorBoundary(
  MoneyInCompaniesBundlingStopAlertInternal,
)
